module.exports = __webpack_public_path__ + "static/img/indexicon3.953b471.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/indexicon3.png
// module id = hdTQ
// module chunks = 1